import i18n from '@/locales'
export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('op_27'),
        action: (obj) => {
          this.createDialog('SetLocalSKUDialog', {
            data: [obj],
            columns: this.columns,
            title: i18n.t('op_27'),
            name: i18n.t('op_25'),
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: obj => ({ validate: obj.sku_id === 0 || obj.sku_id === '' }),
      },
    ]
  },
}
